import { AddressType } from '../../constants/address-type.js';
// Pair both on first create only — once either slot is occupied, offering the pair breaks
// auto-suggested nickname dedup.
export function canCreateSecondaryAlongsideShipping(occupiedTypeIds, typeId, secondaryTypeId) {
    return (typeId === String(AddressType.SHIPPING) &&
        !occupiedTypeIds.includes(String(AddressType.SHIPPING)) &&
        !occupiedTypeIds.includes(String(secondaryTypeId)));
}
//# sourceMappingURL=can-create-secondary-alongside-shipping.js.map